import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { AvatarComponent } from '../avatar/avatar.component';
import { BadgeComponent } from '../badge/badge.component';
import { ButtonComponent } from '../button';
import { IconComponent, type Icon } from '../icon';
import { PopoverModule } from '../popover';

interface Item {
  icon: Icon;
  label: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sb-employee-popover',
  imports: [PopoverModule, TranslatePipe, ButtonComponent, BadgeComponent, IconComponent, AvatarComponent],
  templateUrl: './employee-popover.component.html',
})
export class EmployeePopoverComponent {
  private translate = inject(TranslateService);

  @Input()
  id?: string;
  @Input()
  firstName?: string;
  @Input()
  lastName?: string;
  @Input()
  location?: string;
  @Input()
  department?: string;
  @Input()
  team?: string;
  @Input()
  jobTitle?: string;
  @Input()
  email?: string;
  @Input()
  phone?: string;
  @Input()
  contractEndDate?: string;
  @Input()
  avatarUrl?: string;
  @Input()
  showProfileButton?: boolean;

  @Output()
  viewProfile = new EventEmitter();

  get items(): Item[] {
    const items: Item[] = [];
    if (this.jobTitle) {
      items.push({ icon: 'suitcase', label: this.jobTitle });
    }
    if (this.email) {
      items.push({ icon: 'email', label: this.email });
    }
    if (this.phone) {
      items.push({ icon: 'phone', label: this.phone });
    }
    if (this.contractEndDate) {
      items.push({
        icon: 'calendar-month',
        label: `${this.translate.instant('Contract ends on')} ${this.contractEndDate}`,
      });
    }
    return items;
  }
}
